import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import "../Styles/react-datepicker.css";
import Images from '../Theme/Images';
import { ReactSVG } from 'react-svg';
import SchedulerBg from './SchedulerBg';
import DurationForm from './DurationForm';
import DemoForm from './DemoForm';
import Scheduler from './Scheduler';
import Confirmation from './Confirmation';
import TrialForm from './Trial/TrialForm';
import Success from './Trial/Success';

class SchedulerHome extends Component {

    onLogoClick = () => {
        let link = document.createElement('a');
        link.href = 'https://amygb.ai/'
        document.body.appendChild(link);
        link.click();
    }

    componentDidMount() {
    }

    setBgType = () => {
        if (this.props.location.pathname && this.props.location.pathname.toLowerCase().includes('trial'))
            return 'trial'
        else if (this.props.location.pathname && this.props.location.pathname.toLowerCase().includes('successfulregistration'))
            return 'trial'
        else
            return 'normal'
    }


    render() {
        if (this.props.location.pathname === '/'){
            window.location.href = 'https://www.amygb.ai/contact '
            return
        }
           
        return (
            <div className='pageContainer fullHeight'>
                <div className='fullHeight mainContainer'>
                    <SchedulerBg type={this.setBgType()} />
                    <div className='innerContainer colFlex'>
                        {this.props.location.pathname && this.props.location.pathname.toLowerCase().includes('visionera') ? null : <ReactSVG src={Images.logo} className='cursor' onClick={this.onLogoClick} />}
                        <Switch>
                            <Route path={this.props.match.url + 'visionera/trial'} exact={true} component={() => <TrialForm />} />
                            <Route path={this.props.match.url + 'visionera/successfulRegistration'} exact={true} component={() => <Success />} />

                            <Route path={this.props.match.url} exact component={() => {
                                window.location.href = 'https://www.amygb.ai/contact ';
                                return null;
                            }} />
                            <Route path={this.props.match.url + 'selectDate'} exact={true} component={() => <Scheduler />} />
                            <Route path={this.props.match.url + 'confirmation'} exact={true} component={() => <Confirmation />} />
                            <Route path={this.props.match.url + 'form/:date/:duration/:timezone'} exact={true} component={() => <DemoForm />} />

                        </Switch>
                    </div>
                </div>
            </div>

        )
    }
}
SchedulerHome.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withRouter(SchedulerHome);
